"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callAtExternalVendorStatuses = void 0;
var callAtExternalVendorStatuses;
(function (callAtExternalVendorStatuses) {
    callAtExternalVendorStatuses["PENDING_CALL"] = "pendingCall";
    callAtExternalVendorStatuses["CALL_PERFORMED"] = "callPerformed";
    callAtExternalVendorStatuses["CANCELED"] = "canceled";
    callAtExternalVendorStatuses["SUSPENDED"] = "suspended";
    callAtExternalVendorStatuses["ONGOING_CALL"] = "ongoingCall";
})(callAtExternalVendorStatuses || (exports.callAtExternalVendorStatuses = callAtExternalVendorStatuses = {}));
